export default __webpack_public_path__ + "static/13-f2d5b93ae072b785cc6f9b7f6e06246c.jpg";